

module.exports = __webpack_require__.stylable.create(
    "IconButton3366391759",
    {"classes":{"root":"IconButton3366391759__root","icon":"IconButton3366391759__icon","skin-line":"IconButton3366391759__skin-line","skin-full":"IconButton3366391759__skin-full"},"vars":{},"stVars":{"DefaultColor":"color-5","DefaultBackgroundColor":"color-1","DisabledColor":"color-3","IconColor":"--overridable","BackgroundColor":"--overridable"},"keyframes":{}},
    "",
    3,
    "IconButton3366391759",
    null
);
